import { useState, useEffect } from "react";
import { supabase, KoreanBriefRow } from "../lib/supabase";

export const useKoreanBrief = (limit = 4) => {
  const [articles, setArticles] = useState<KoreanBriefRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetch = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from("korean_brief")
          .select("*")
          .eq("is_published", true)
          .order("published_at", { ascending: false })
          .limit(limit);
        if (!cancelled && !error && data && data.length > 0) {
          setArticles(data as KoreanBriefRow[]);
          setLoading(false);
          return;
        }
      } catch {/* fallthrough */}
      if (!cancelled) {
        // Return empty so fallback mock shows
        setArticles([]);
        setLoading(false);
      }
    };
    fetch();
    return () => { cancelled = true; };
  }, [limit]);

  return { articles, loading };
};
